const formatterState=function ({ cellValue }){
  switch (cellValue) {
    case 1:
      return "启用";
    case 2:
      return "禁用";
  }
}
const state = {
  selectedInstitution: false, //是否已选择机构
  institutions:JSON.parse(sessionStorage.getItem('institutions'))||'',
};
const getters = {
  getInstitutionsData:state=>state.institutions,
};
const mutations={
  selectInstitution:(state,data)=>{
    state.selectedInstitution=data.data
  },
}
export default {
  state,
  getters,
  mutations,
};
